import {Prompt} from 'react-router-dom';
import React, {useEffect, useState} from "react";
import {PillButton} from "./PillButton";
import {Modal} from "./Modal";
import {useRenderableData} from "./hooks/useRenderableData";

export let LeaveWithoutSavingWarningModal = function (props) {
    useEffect(function () {
        props.navWarningDisplayValueManager.reactToValueChangeWith(handleNavWarningDisplayRequest);
        props.confirmBeforeNavValueManager.reactToValueChangeWith(handleConfirmBeforeNavRequest);
    }, []);

    let warningModalRenderableData = useRenderableData({
        showLeaveWithoutSavingWarningModal: false,
        confirmBeforeNav: false,
        getUserConfirmationCallback: null
    })

    const [userConfirmationCallbackToRun, setUserConfirmationCallbackToRun] = useState(null);

    function handleNavWarningDisplayRequest(warningModalSettings) {
        warningModalRenderableData.updateAndRender({
            showLeaveWithoutSavingWarningModal: warningModalSettings.showLeaveWithoutSavingWarningModal,
            getUserConfirmationCallback: warningModalSettings.getUserConfirmationCallback,
        });
    }

    function handleConfirmBeforeNavRequest(promptRequest) {
        warningModalRenderableData.updateAndRender({
            confirmBeforeNav: promptRequest.confirmBeforeNav,
        });
    }

    function cancel() {
        const getUserConfirmationCallback = warningModalRenderableData.getUserConfirmationCallback;

        warningModalRenderableData.updateAndRender({
            showLeaveWithoutSavingWarningModal: false,
            getUserConfirmationCallback: null,
        });

        if (getUserConfirmationCallback) {
            setUserConfirmationCallbackToRun(() => getUserConfirmationCallback(false))
        }
    }

    function leaveWithoutSaving() {
        const getUserConfirmationCallback = warningModalRenderableData.getUserConfirmationCallback;

        warningModalRenderableData.updateAndRender({
            showLeaveWithoutSavingWarningModal: false,
            getUserConfirmationCallback: null,
        });

        setUserConfirmationCallbackToRun(() => getUserConfirmationCallback(true));
    }

    // run user conf callback after renders where it changes
    // todo - there's probably a better way to do this
    useEffect(
        function () {
            if (userConfirmationCallbackToRun) {
                userConfirmationCallbackToRun();
                setUserConfirmationCallbackToRun(null);
            }
        },
        [userConfirmationCallbackToRun]
    )

    return (
        <div>
            {/*
             This Prompt doesn't actually display anything, but triggering its "when" prop to
             true and returning a string from the "message" function is necessary to block
             navigation.  After that block occurs, BrowserRouter calls its getUserConfirmation
             prop function to determine what to actually display - I have it set to trigger the
             display of the modal defined below under the Prompt.
             */}
            <Prompt
                when={warningModalRenderableData.confirmBeforeNav}
                message={function () {
                    return 'You have unsaved changes. Are you sure you want to leave without saving?';
                }}
            />
            {(() => {
                if (warningModalRenderableData.showLeaveWithoutSavingWarningModal) {
                    return (
                        <Modal
                            boxClass="leave-without-saving-warning-modal"
                            headerText="Leave Without Saving?"
                            onClickCloseOption={cancel}
                        >
                            <div className="leave-without-saving-warning-modal-body">
                                You have unsaved changes. Are you sure you want to leave without saving?
                            </div>

                            <div className="leave-without-saving-warning-modal-options">
                                <div className="leave-without-saving-warning-modal-option">
                                    <PillButton
                                        onClick={cancel}
                                        buttonClasses="leave-without-saving-warning-modal-button leave-without-saving-warning-modal-cancel-button"
                                        buttonText="CANCEL"
                                        buttonTextClasses="leave-without-saving-warning-modal-button-text"
                                    />
                                </div>
                                <div className="leave-without-saving-warning-modal-option">
                                    <PillButton
                                        onClick={leaveWithoutSaving}
                                        buttonClasses="leave-without-saving-warning-modal-button leave-without-saving-warning-modal-leave-button"
                                        buttonText="LEAVE WITHOUT SAVING"
                                        buttonTextClasses="leave-without-saving-warning-modal-button-text"
                                    />
                                </div>
                            </div>
                        </Modal>
                    );
                }
            })()}
        </div>
    );
};
